// localStorage that never throws: with site data blocked (a kiosk profile,
// Safari blocking all cookies, some private windows) every access throws,
// and one unguarded read at the store's creation left a blank app (WEB-39).
// A setting then lasts as long as the page.

export function getItem(key: string): string | null {
    try {
        return localStorage.getItem(key)
    } catch {
        return null
    }
}

export function setItem(key: string, value: string) {
    try {
        localStorage.setItem(key, value)
    } catch {
        /* storage blocked: this page keeps it */
    }
}

// stored reads a JSON value; a missing or bad one is the default (a bad one
// blanked the whole app on mount)
export function stored<T>(key: string, def: T): T {
    const v = getItem(key)
    if (v === null) return def
    try {
        return JSON.parse(v) as T
    } catch {
        return def
    }
}

export function store(key: string, value: unknown) {
    setItem(key, JSON.stringify(value))
}
